import { Component, Inject } from '@angular/core';
// import {TranslateService} from "@ngx-translate/core";
import { LANGS, TlumaczeniaService } from './core/tlumaczenia/serwisy/tlumaczenia.service';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'core.strona-startowa.tytul';
  wersjaAplikacji = '#WERSJA#';
  constructor(private tlumaczeniaService: TlumaczeniaService,
    private titleService: Title,
    private router: Router,
    // private komunikatyService: KomunikatyService,
    @Inject(DOCUMENT) private document: Document) {
    this.inicjujJezyk();
    // komunikatyService.init();
    this.tlumaczeniaService.getZmianaJezykaSubject().subscribe(jezyk => {
      document.getElementsByTagName('html')[0].setAttribute('lang', jezyk);
    });
    this.wypiszWersjeAplikacji();
  }

  /**
   * Funkcja przy starcie, dodaje do logów informacje owersji.
   */
  private wypiszWersjeAplikacji() {
  }

  /**
   * Funkcja inicjuje jezyk aplikacji
   */
  private inicjujJezyk(): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const lang = urlParams.get('lang');
    if (lang) {
      this.tlumaczeniaService.init(lang);
      return;
    }
    this.tlumaczeniaService.init(LANGS.PL);
  }
  ngOnInit() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        switch (decodeURI(this.router.url)) {
          case '/strony/Warunki_ponownego_wykorzystania_informacji_publicznej':
            return 'Warunki ponownego wykorzystania informacji publicznej';
          case '/strony/polityka_prywatnosci':
            return 'Polityka prywatności';
          case '/strony/Usługi-BGiK':
            return 'Usługi BGiK';
          case '/strony/Informacje-o-serwisie':
            return 'Informacje o serwisie';
            case '/strony/krotka_historia_warszawy':
            return 'Krótka historia Warszawy';
        }
        let route: ActivatedRoute = this.router.routerState.root;
        let routeTitle = '';
        while (route!.firstChild) {
          route = route.firstChild;
        }
        if (route.snapshot.data['title']) {
          routeTitle = route!.snapshot.data['title'];
        }
        return routeTitle;
      })
    )
      .subscribe((title: string) => {
        if (title) {
          this.titleService.setTitle(title);
        }
      });
  }
}
